import { useState } from 'react'

import cn from 'classnames'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import hourglassLogo from '@src/assets/images/HG-Logo-White-Font-p-500.png'
import machLogo from '@src/assets/images/machLogo.svg'
import ConnectButton from '@src/components/buttons/ConnectButton'
import PendingTransactionsButton from '@src/components/buttons/PendingTransactionsButton'
import { MainMenu } from '@src/configs/menu'
import * as PATH from '@src/configs/paths'
import { useClickOutside } from '@src/hooks/utils/useClickOutside'
import { IMenuItem } from '@src/types/menu'

const Header = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false)
    const ref = useClickOutside(() => setIsMenuOpened(false))

    const logoImage = window.location.href.includes('hourglass') ? (
        <img className='w-32 cursor-pointer md:w-36' src={hourglassLogo} onClick={() => navigate(PATH.LANDING)} />
    ) : (
        <img className='h-8 cursor-pointer' src={machLogo} onClick={() => navigate(PATH.LANDING)} />
    )

    const renderWalletButtons = () => {
        if (window.location.pathname === PATH.ABOUT) return null

        return (
            <div className='left-container ml-0 hidden items-center justify-center gap-2 space-y-2 md:order-2 md:ml-5 md:flex md:justify-end md:space-x-4 md:space-y-0'>
                <PendingTransactionsButton className='md:mr-2' />
                <ConnectButton />
            </div>
        )
    }

    return (
        <header
            className='container flex items-start justify-between py-5 pt-10 font-geist tracking-tightest'
            ref={ref}
        >
            <div className='flex items-start'>{logoImage}</div>
            <nav className='flex-1 px-8'>
                <div className='hidden md:flex md:items-center md:justify-center'>
                    {MainMenu.map((menu: IMenuItem, index: number) => (
                        <Link
                            className={cn(
                                'px-4 py-2 transition-colors hover:text-opacity-50',
                                menu.navigation === pathname || (pathname === '/' && menu.label === 'Swap')
                                    ? 'text-white'
                                    : 'text-sub-text'
                            )}
                            key={index}
                            to={menu.navigation}
                            target={menu.target}
                        >
                            {menu.label}
                        </Link>
                    ))}
                </div>
            </nav>

            <div className='flex items-center'>
                {renderWalletButtons()}
                <div
                    className='relative h-6 w-5 cursor-pointer transition-all hover:opacity-70 md:hidden'
                    onClick={() => setIsMenuOpened(prev => !prev)}
                >
                    <span
                        className={cn(
                            'absolute top-0 block h-1 w-6 bg-[#9e9e9e] transition-all',
                            isMenuOpened ? 'origin-top-left rotate-45' : ''
                        )}
                    ></span>
                    <span
                        className={cn(
                            'absolute top-2 block h-1 w-6 bg-[#9e9e9e] transition-all',
                            isMenuOpened ? 'opacity-0' : ''
                        )}
                    ></span>
                    <span
                        className={cn(
                            'absolute top-4 block h-1 w-6 bg-[#9e9e9e] transition-all',
                            isMenuOpened ? 'origin-bottom-left -rotate-45' : ''
                        )}
                    ></span>
                </div>
            </div>

            {isMenuOpened && (
                <div className='fixed left-0 right-0 top-24 z-50 flex flex-col rounded-b-2xl border-b border-b-white/30 bg-background p-4'>
                    {MainMenu.map((menu: IMenuItem, index: number) => (
                        <Link
                            className={cn(
                                'py-5 text-center transition-all hover:text-white',
                                menu.navigation === pathname ? 'text-white' : 'text-sub-text'
                            )}
                            key={index}
                            to={menu.navigation}
                            onClick={() => setIsMenuOpened(false)}
                        >
                            {menu.label}
                        </Link>
                    ))}
                    {window.location.pathname !== PATH.ABOUT && (
                        <div className='flex flex-col items-center space-y-2'>
                            <div className='flex flex-col items-center space-y-4 md:flex-row md:space-y-0'>
                                <PendingTransactionsButton className='md:mr-2' />
                                <ConnectButton />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </header>
    )
}

export default Header
